import { Link } from "react-router-dom";
import heroImage from "../../public_html/assets/images/hero-beauty.svg";
import { CategoryCard, ProductCard } from "../components/Cards";
import { DeliveryNotice } from "../components/DeliveryNotice";
import { Meta } from "../components/Meta";
import { homepageCategoryTileAuroraIds, homepageFeaturedAuroraIds } from "../config/homepage";
import { routes } from "../config/routes";
import {
  categoryId,
  findVisibleProduct,
  productsByAuroraIds,
  visibleCategories,
  visibleProducts
} from "../data/catalogue";

export function HomePage() {
  const listings = visibleProducts();
  const categories = visibleCategories();
  const featured = productsByAuroraIds(homepageFeaturedAuroraIds);

  return (
    <main id="main">
      <Meta
        title="Beautify Ourselves | Beauty, chosen with care"
        description="Browse the Beautify Ourselves preview catalogue. Preview prices may change before ordering opens."
        path="/"
      />
      <section className="hero hero-compact">
        <div className="hero-copy">
          <p className="eyebrow">A more considered beauty shop</p>
          <h1>
            Beauty should feel <em>clear, personal,</em> and yours.
          </h1>
          <p className="lead">
            Browse {listings.length} preview listings. Photos, names and preview prices are
            shown now. Nothing can be purchased yet, and prices may change before ordering
            opens.
          </p>
          <div className="hero-actions">
            <Link className="button" to={routes.shop}>
              Browse the collection
            </Link>
            <Link className="button button-secondary" to={routes.search}>
              Search products
            </Link>
          </div>
        </div>
        <div className="hero-art">
          <img
            src={heroImage}
            alt="Abstract beauty still life in warm rose tones"
            width="900"
            height="1100"
          />
        </div>
      </section>

      <DeliveryNotice variant="strip" />

      {featured.length > 0 && (
        <section className="section section-tight shop-catalogue" aria-labelledby="preview-heading">
          <div className="section-inner">
            <div className="section-heading">
              <div>
                <p className="eyebrow">From the collection</p>
                <h2 id="preview-heading">A first look at real listings.</h2>
              </div>
              <Link className="text-link" to={routes.shop}>
                View all {listings.length} listings <span aria-hidden="true">→</span>
              </Link>
            </div>
            <div className="product-grid product-grid-featured">
              {featured.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="section section-tight" aria-labelledby="categories-heading">
        <div className="section-inner">
          <div className="section-heading">
            <div>
              <p className="eyebrow">Browse by category</p>
              <h2 id="categories-heading">Find a starting point.</h2>
            </div>
            <p>
              Categories are a browsing guide from product names and pack sizes. They are not
              a verified product-type classification.
            </p>
          </div>
          <div className="category-grid category-grid-dense">
            {categories.map((category) => {
              const tileProduct = findVisibleProduct(homepageCategoryTileAuroraIds[category.id]);
              return (
                <CategoryCard
                  key={category.id}
                  category={category}
                  count={listings.filter((product) => categoryId(product) === category.id).length}
                  tileImage={tileProduct?.images[0]}
                />
              );
            })}
          </div>
        </div>
      </section>

      <section className="section steps steps-compact" aria-labelledby="collection-heading">
        <div className="section-inner">
          <p className="eyebrow">Before ordering opens</p>
          <h2 id="collection-heading">What you can see now.</h2>
          <div className="steps-grid">
            <article className="step">
              <h3>Browse and search</h3>
              <p>Names, pack sizes, categories, matched product photos and preview prices are listed for every imported item.</p>
            </article>
            <article className="step">
              <h3>Preview prices only</h3>
              <p>Amounts may change. Delivery is charged separately and has not been set yet.</p>
            </article>
            <article className="step">
              <h3>No purchases yet</h3>
              <p>Checkout, payments and Ireland ordering stay closed until the remaining checks are complete.</p>
            </article>
          </div>
          <p className="home-close">
            We do not invent ingredients, stock claims or delivery times.
            {" "}
            <Link className="text-link" to={routes.shop}>
              Continue to Shop <span aria-hidden="true">→</span>
            </Link>
          </p>
        </div>
      </section>
    </main>
  );
}
